import { useEffect, useState } from 'react';
import { Booking, ResourceCompressed } from '@jooxter/api';
import { toISO, createGTMUpdateVirtualPathEvent } from '@jooxter/utils';
import { JxtBookingForm } from '../../forms';
import { IMoveFormOverride } from '../../forms/Booking/types/booking-form.types';
import { IJxtBookingFormContainer } from './types';

const KEY_PREFIX = 'JxtBookingFormContainer';
const KEY_NO_RESOURCE = 'No_Resource';
const KEY_NO_FROM = 'No_From';
const KEY_NO_TO = 'No_To';

export const JxtBookingFormContainer = ({
  bookingToEdit,
  bookingFormPreset,
  slotToBookInstantly,
  onSuccess,
}: IJxtBookingFormContainer) => {
  // Set when the overlap-resolution flow's "move to new resource" choice is confirmed: pivots this
  // container from creating a new booking into editing `pivot.booking` with `pivot.resource` swapped
  // in, and `pivot.formOverride` reused as the form's own values instead of `pivot.booking`'s.
  const [pivot, setPivot] = useState<{
    booking: Booking;
    resource: ResourceCompressed;
    formOverride: IMoveFormOverride;
  }>();
  const effectiveBookingToEdit = pivot ? { ...pivot.booking, resource: pivot.resource } : bookingToEdit;
  const key = `${KEY_PREFIX}-${pivot?.booking.id ?? 'No_Pivot'}-${bookingFormPreset?.resource?.id ?? KEY_NO_RESOURCE}-${bookingFormPreset?.from ? toISO(bookingFormPreset?.from) : KEY_NO_FROM}-${bookingFormPreset?.to ? toISO(bookingFormPreset?.to) : KEY_NO_TO}`;

  useEffect(() => {
    createGTMUpdateVirtualPathEvent('/Slider Booking');
  }, []);

  return (
    <div key={key} className="h-full max-sm:h-[calc(88vh-177px)]">
      <JxtBookingForm
        bookingToEdit={effectiveBookingToEdit}
        bookingFormPreset={bookingFormPreset}
        slotToBookInstantly={slotToBookInstantly}
        onSuccess={onSuccess}
        onMoveToNewResource={(booking, resource, formOverride) => setPivot({ booking, resource, formOverride })}
        moveFormOverride={pivot?.formOverride}
      />
    </div>
  );
};

export default JxtBookingFormContainer;
